var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    { staticClass: "os-card" },
    [
      _c("h3", { staticClass: "text-center mb-5" }, [
        _vm._v(_vm._s(_vm.$helpers.getMetaTitleText(_vm.$route)))
      ]),
      _vm._v(" "),
      _c(
        "b-alert",
        {
          attrs: { variant: "danger" },
          model: {
            value: _vm.form.state.errors,
            callback: function($$v) {
              _vm.$set(_vm.form.state, "errors", $$v)
            },
            expression: "form.state.errors"
          }
        },
        [_vm._v(_vm._s(_vm.$t("signupOH.errors.general-code")))]
      ),
      _vm._v(" "),
      _vm.form.state.submitted && _vm.form.state.unauthorized
        ? _c("b-alert", { attrs: { show: "", variant: "danger" } }, [
            _c("div", { domProps: { innerHTML: _vm._s(_vm.submitError) } })
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.userRegistered
        ? _c(
            "b-form",
            {
              on: {
                submit: function($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                  return _vm.signUpCheck.apply(null, arguments)
                }
              }
            },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { staticClass: "px-3", attrs: { sm: "12", xl: "6" } },
                    [
                      !_vm.inOpenlegal() &&
                      !_vm.$store.getters["session/referralActiveByApiClient"]
                        ? _c(
                            "b-form-group",
                            [
                              _c("b-form-input", {
                                attrs: {
                                  type: "text",
                                  placeholder: _vm.$t(
                                    "signupOH.registerCodeEnt"
                                  ),
                                  state: _vm.companyCodeIsValid
                                },
                                on: {
                                  blur: _vm.checkCompanyCode,
                                  input: function($event) {
                                    return _vm.resetForm()
                                  }
                                },
                                model: {
                                  value: _vm.$v.form.companyCode.$model,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.$v.form.companyCode,
                                      "$model",
                                      $$v
                                    )
                                  },
                                  expression: "$v.form.companyCode.$model"
                                }
                              }),
                              _vm._v(" "),
                              !_vm.inOpensalud360() &&
                              (!_vm.$v.form.companyCode.$model ||
                                _vm.companyCodeIsValid)
                                ? _c("b-form-text", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "signupOH.justIndicatedByBusiness"
                                        )
                                      )
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.form.trySubmit
                                ? _c(
                                    "b-form-invalid-feedback",
                                    {
                                      attrs: {
                                        state:
                                          !_vm.inOpensalud360() ||
                                          _vm.companyCodeIsValid == true
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("signupOH.errors.enterCode")
                                        )
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.inOpenlegal()
                        ? _c(
                            "transition",
                            { attrs: { name: "slide-fade" } },
                            [
                              _vm.codeInfo.generic
                                ? _c(
                                    "b-form-group",
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          type: "text",
                                          placeholder:
                                            _vm.reservationNumberPlaceholder,
                                          state: _vm.validateState(
                                            "reservationNumber"
                                          )
                                        },
                                        model: {
                                          value:
                                            _vm.$v.form.reservationNumber
                                              .$model,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.$v.form.reservationNumber,
                                              "$model",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "$v.form.reservationNumber.$model"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("b-form-invalid-feedback", [
                                        _vm._v(
                                          _vm._s(_vm.reservationNumberErrorMsg)
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.inOpenlegal() && _vm.inOpensalud360()
                        ? _c(
                            "transition",
                            { attrs: { name: "slide-fade" } },
                            [
                              _vm.employeeGroupFieldIsVisible
                                ? _c(
                                    "b-form-group",
                                    [
                                      _c("base-select", {
                                        attrs: {
                                          options: _vm.codeInfo.employeeGroup,
                                          valueProp: "id",
                                          label: "groupName",
                                          placeholder: _vm.$t(
                                            "signupOH.center-or-business-unit"
                                          ),
                                          state: _vm.validateState(
                                            "employeeGroup"
                                          ),
                                          errorMsg: _vm.$t(
                                            "signupOH.errors.center-or-business-unit"
                                          )
                                        },
                                        model: {
                                          value:
                                            _vm.$v.form.employeeGroup.$model,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.$v.form.employeeGroup,
                                              "$model",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "$v.form.employeeGroup.$model"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.employeeGroupFreeFieldIsVisible
                                ? _c(
                                    "b-form-group",
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          placeholder: _vm.$t(
                                            "signupOH.employeeLocation"
                                          ),
                                          state: _vm.validateState(
                                            "employeeLocation"
                                          ),
                                          errorMsg: _vm.$t(
                                            "signupOH.errors.employeeLocation"
                                          )
                                        },
                                        model: {
                                          value:
                                            _vm.$v.form.employeeLocation.$model,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.$v.form.employeeLocation,
                                              "$model",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "$v.form.employeeLocation.$model"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.inOpenlegal() && _vm.inOpensalud360()
                        ? _c(
                            "transition",
                            { attrs: { name: "fade" } },
                            [
                              _vm.employeeNumberFieldIsVisible
                                ? _c(
                                    "b-form-group",
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          placeholder: _vm.$t(
                                            "signupOH.internal-code"
                                          ),
                                          state: _vm.employeeNumberState,
                                          errorMsg: _vm.$t(
                                            "signupOH.errors.required-employee-number"
                                          )
                                        },
                                        on: {
                                          input: function($event) {
                                            _vm.resetEmployeeNumberValidation()
                                            _vm.resetForm()
                                          },
                                          blur: function($event) {
                                            return _vm.$v.form.employeeNumber.$touch()
                                          }
                                        },
                                        model: {
                                          value:
                                            _vm.$v.form.employeeNumber.$model,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.$v.form.employeeNumber,
                                              "$model",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "$v.form.employeeNumber.$model"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _vm.employeeNumberIsValid === false
                                        ? _c("b-form-invalid-feedback", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "signupOH.errors.employee-number"
                                                )
                                              )
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.$v.form.employeeNumber.$dirty &&
                                      _vm.$v.form.employeeNumber.$invalid &&
                                      _vm.employeeNumberIsValid !== false
                                        ? _c("b-form-invalid-feedback", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "signupOH.errors.required-employee-number"
                                                )
                                              )
                                            )
                                          ])
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.inOpenlegal()
                        ? _c(
                            "transition",
                            { attrs: { name: "slide-fade" } },
                            [
                              _vm.isTravelCompany
                                ? _c(
                                    "b-row",
                                    [
                                      _c(
                                        "b-col",
                                        { attrs: { sm: "12", xl: "12" } },
                                        [
                                          _c("base-datepicker", {
                                            attrs: {
                                              "value-as-date": "",
                                              state: _vm.validateState(
                                                "reservationFromDate"
                                              ),
                                              placeholder: _vm.$t(
                                                "signupOH.checkin-date"
                                              ),
                                              validator:
                                                _vm.$v.form.reservationFromDate
                                            },
                                            model: {
                                              value:
                                                _vm.$v.form.reservationFromDate
                                                  .$model,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.$v.form
                                                    .reservationFromDate,
                                                  "$model",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "$v.form.reservationFromDate.$model"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        { attrs: { sm: "12", xl: "12" } },
                                        [
                                          _c("base-datepicker", {
                                            attrs: {
                                              "value-as-date": "",
                                              state: _vm.validateState(
                                                "reservationToDate"
                                              ),
                                              placeholder: _vm.$t(
                                                "signupOH.checkout-date"
                                              ),
                                              validator:
                                                _vm.$v.form.reservationToDate,
                                              parentValidators: _vm.$v.form
                                            },
                                            model: {
                                              value:
                                                _vm.$v.form.reservationToDate
                                                  .$model,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.$v.form.reservationToDate,
                                                  "$model",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "$v.form.reservationToDate.$model"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.form.companyCode || _vm.codeInfo.codeType != 2
                        ? _c(
                            "b-form-group",
                            [
                              _c("b-form-input", {
                                attrs: {
                                  type: "text",
                                  placeholder: _vm.$t("signupOH.registerName"),
                                  state: _vm.validateState("name")
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.resetForm()
                                  }
                                },
                                model: {
                                  value: _vm.$v.form.name.$model,
                                  callback: function($$v) {
                                    _vm.$set(_vm.$v.form.name, "$model", $$v)
                                  },
                                  expression: "$v.form.name.$model"
                                }
                              }),
                              _vm._v(" "),
                              _c("b-form-invalid-feedback", [
                                _vm._v(
                                  _vm._s(_vm.$t("signupOH.errors.enterName"))
                                )
                              ])
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.form.companyCode && _vm.codeInfo.codeType === 2
                        ? _c(
                            "b-form-group",
                            [
                              _c("b-form-input", {
                                attrs: {
                                  type: "text",
                                  placeholder: _vm.$t(
                                    "signupOH.registerNameCenterResidence"
                                  ),
                                  state: _vm.validateState("name")
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.resetForm()
                                  }
                                },
                                model: {
                                  value: _vm.$v.form.name.$model,
                                  callback: function($$v) {
                                    _vm.$set(_vm.$v.form.name, "$model", $$v)
                                  },
                                  expression: "$v.form.name.$model"
                                }
                              }),
                              _vm._v(" "),
                              _c("b-form-invalid-feedback", [
                                _vm._v(
                                  _vm._s(_vm.$t("signupOH.errors.enterName"))
                                )
                              ])
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.form.companyCode || _vm.codeInfo.codeType != 2
                        ? _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "pr-md-1 pr-0",
                                  attrs: { sm: "12", xl: "6" }
                                },
                                [
                                  _c(
                                    "b-form-group",
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          type: "text",
                                          placeholder: _vm.$t(
                                            "signupOH.registerSurname1"
                                          ),
                                          state: _vm.validateState(
                                            "firstSurname"
                                          )
                                        },
                                        on: {
                                          input: function($event) {
                                            return _vm.resetForm()
                                          }
                                        },
                                        model: {
                                          value:
                                            _vm.$v.form.firstSurname.$model,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.$v.form.firstSurname,
                                              "$model",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "$v.form.firstSurname.$model"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("b-form-invalid-feedback", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "signupOH.errors.enterSurname1"
                                            )
                                          )
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                {
                                  staticClass: "pl-md-1 pl-0",
                                  attrs: { sm: "12", xl: "6" }
                                },
                                [
                                  _c(
                                    "b-form-group",
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          type: "text",
                                          placeholder: _vm.$t(
                                            "signupOH.registerSurname2"
                                          ),
                                          state: _vm.validateState(
                                            "secondSurname"
                                          )
                                        },
                                        on: {
                                          input: function($event) {
                                            return _vm.resetForm()
                                          }
                                        },
                                        model: {
                                          value:
                                            _vm.$v.form.secondSurname.$model,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.$v.form.secondSurname,
                                              "$model",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "$v.form.secondSurname.$model"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("b-form-invalid-feedback", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "signupOH.errors.enterSurname2"
                                            )
                                          )
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.$uiHelpers.isMobile ? _c("br") : _vm._e(),
                      _vm._v(" "),
                      _c("b-form-group", [
                        !_vm.form.companyCode || _vm.codeInfo.codeType != 2
                          ? _c(
                              "div",
                              { staticClass: "inline-input text-center" },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "text-uppercase pr-4 d-inline-block genderText"
                                  },
                                  [_vm._v(_vm._s(_vm.$t("signupOH.genderSex")))]
                                ),
                                _vm._v(" "),
                                _c("radio-button-gender", {
                                  staticClass: "d-inline-block",
                                  attrs: {
                                    state: _vm.validateState("gender"),
                                    errorMsg: _vm.$t("signupOH.errors.enterSex")
                                  },
                                  model: {
                                    value: _vm.$v.form.gender.$model,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.$v.form.gender,
                                        "$model",
                                        $$v
                                      )
                                    },
                                    expression: "$v.form.gender.$model"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      !_vm.form.companyCode || _vm.codeInfo.codeType != 2
                        ? _c(
                            "div",
                            { staticClass: "inline-input text-center" },
                            [
                              _c("base-birthdate-input", {
                                model: {
                                  value: _vm.form.birthDate,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "birthDate", $$v)
                                  },
                                  expression: "form.birthDate"
                                }
                              }),
                              _vm._v(" "),
                              _vm.form.trySubmit
                                ? _c(
                                    "b-form-invalid-feedback",
                                    {
                                      attrs: {
                                        state: _vm.validateState("birthDate")
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "signupOH.errors.enterBirthdate"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        [
                          _c("base-select", {
                            attrs: {
                              id: "country",
                              searchable: true,
                              placeholder: _vm.$t("signupOH.country"),
                              options: _vm.form.selectedCountry.options,
                              state: _vm.validateState("countryId"),
                              label: _vm.$i18nHelpers.normalizeProp("name"),
                              valueProp: "idCountry",
                              errorMsg: _vm.$t("signupOH.errors.enterCountry"),
                              clearable: false
                            },
                            on: { change: _vm.reCallProvince },
                            model: {
                              value: _vm.$v.form.countryId.$model,
                              callback: function($$v) {
                                _vm.$set(_vm.$v.form.countryId, "$model", $$v)
                              },
                              expression: "$v.form.countryId.$model"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        [
                          _c("base-select", {
                            attrs: {
                              id: "province",
                              searchable: true,
                              placeholder: _vm.$t(
                                "signupOH.registerYourProvince"
                              ),
                              state: _vm.validateState("stateId"),
                              options: _vm.form.selectProvince.options,
                              label: _vm.$i18nHelpers.normalizeProp("name"),
                              valueProp: "id"
                            },
                            model: {
                              value: _vm.$v.form.stateId.$model,
                              callback: function($$v) {
                                _vm.$set(_vm.$v.form.stateId, "$model", $$v)
                              },
                              expression: "$v.form.stateId.$model"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "px-3", attrs: { sm: "12", xl: "6" } },
                    [
                      _vm.codeInfo.codeType != 2
                        ? _c(
                            "div",
                            [
                              _vm.form.countryId === 28
                                ? _c(
                                    "b-form-group",
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          type: "text",
                                          placeholder: _vm.$t(
                                            "signupOH.registerNIF"
                                          ),
                                          state: _vm.validateState("nif")
                                        },
                                        on: {
                                          input: function($event) {
                                            return _vm.resetForm()
                                          }
                                        },
                                        model: {
                                          value: _vm.$v.form.nif.$model,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.$v.form.nif,
                                              "$model",
                                              $$v
                                            )
                                          },
                                          expression: "$v.form.nif.$model"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _vm.form.trySubmit && _vm.dniregistered
                                        ? _c(
                                            "b-form-invalid-feedback",
                                            {
                                              attrs: {
                                                state: _vm.dniregistered != true
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n            " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "signupOH.errors.duplicatedNIF"
                                                    )
                                                  )
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.form.trySubmit &&
                                      _vm.dniregistered != true
                                        ? _c(
                                            "b-form-invalid-feedback",
                                            {
                                              attrs: {
                                                state:
                                                  _vm.form.nif != null
                                                    ? _vm.validateNIF(
                                                        _vm.form.nif
                                                      )
                                                    : false
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n            " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "signupOH.errors.enterNIF"
                                                    )
                                                  )
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.form.countryId === 42
                                ? _c(
                                    "b-form-group",
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          type: "text",
                                          placeholder: _vm.$t(
                                            "signupOH.enterCURP"
                                          )
                                        },
                                        on: {
                                          input: function($event) {
                                            return _vm.resetForm()
                                          }
                                        },
                                        model: {
                                          value: _vm.$v.form.nif.$model,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.$v.form.nif,
                                              "$model",
                                              $$v
                                            )
                                          },
                                          expression: "$v.form.nif.$model"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _vm.form.trySubmit && _vm.dniregistered
                                        ? _c(
                                            "b-form-invalid-feedback",
                                            {
                                              attrs: {
                                                state: _vm.dniregistered != true
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n            " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "signupOH.errors.duplicatedNIF"
                                                    )
                                                  )
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.form.trySubmit &&
                                      _vm.dniregistered != true
                                        ? _c(
                                            "b-form-invalid-feedback",
                                            {
                                              attrs: {
                                                state: _vm.form.nif != null
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n            " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "signupOH.errors.enterCURP"
                                                    )
                                                  )
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.form.countryId !== 42 &&
                              _vm.form.countryId !== 28
                                ? _c(
                                    "b-form-group",
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          type: "text",
                                          placeholder: _vm.$t(
                                            "signupOH.enterId"
                                          )
                                        },
                                        on: {
                                          input: function($event) {
                                            return _vm.resetForm()
                                          }
                                        },
                                        model: {
                                          value: _vm.$v.form.nif.$model,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.$v.form.nif,
                                              "$model",
                                              $$v
                                            )
                                          },
                                          expression: "$v.form.nif.$model"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _vm.form.trySubmit && _vm.dniregistered
                                        ? _c(
                                            "b-form-invalid-feedback",
                                            {
                                              attrs: {
                                                state: _vm.dniregistered != true
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n            " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "signupOH.errors.duplicatedNIF"
                                                    )
                                                  )
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.form.trySubmit &&
                                      _vm.dniregistered != true
                                        ? _c(
                                            "b-form-invalid-feedback",
                                            {
                                              attrs: {
                                                state: _vm.form.nif != null
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n            " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "signupOH.errors.enterID"
                                                    )
                                                  )
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        [
                          _c("b-form-input", {
                            attrs: {
                              type: "text",
                              placeholder: _vm.$t("signupOH.registerEmail"),
                              state: _vm.validateState("email")
                            },
                            on: {
                              blur:
                                _vm.ivecoAndExtensionEmailForEmployeeNumberInputDisplay,
                              input: function($event) {
                                return _vm.resetForm()
                              }
                            },
                            model: {
                              value: _vm.$v.form.email.$model,
                              callback: function($$v) {
                                _vm.$set(_vm.$v.form.email, "$model", $$v)
                              },
                              expression: "$v.form.email.$model"
                            }
                          }),
                          _vm._v(" "),
                          _c("b-form-invalid-feedback", [
                            _vm._v(_vm._s(_vm.$t("signupOH.errors.enterEmail")))
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        [
                          _c("b-form-input", {
                            attrs: {
                              type: "text",
                              placeholder: _vm.$t("signupOH.confirmEmail"),
                              state: _vm.validateState("emailConfirmation")
                            },
                            on: {
                              input: function($event) {
                                return _vm.resetForm()
                              }
                            },
                            model: {
                              value: _vm.$v.form.emailConfirmation.$model,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.$v.form.emailConfirmation,
                                  "$model",
                                  $$v
                                )
                              },
                              expression: "$v.form.emailConfirmation.$model"
                            }
                          }),
                          _vm._v(" "),
                          _c("b-form-invalid-feedback", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("signupOH.errors.enterConfirmEmail")
                              )
                            )
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { staticClass: "align-items-center" },
                        [
                          _c(
                            "b-col",
                            {
                              staticClass: "pr-md-2 pr-0",
                              attrs: { sm: "12", xl: "5" }
                            },
                            [
                              _c(
                                "b-form-group",
                                [
                                  _c("base-select", {
                                    attrs: {
                                      id: "prefix",
                                      searchable: true,
                                      placeholder: _vm.$t(
                                        "signupOH.registerPhonePrefix"
                                      ),
                                      options: _vm.form.selectPrefix.options,
                                      state: _vm.validateState("prefixCountry"),
                                      label: _vm.$i18nHelpers.normalizeProp(
                                        "prefixAndCountry"
                                      ),
                                      valueProp: "phonePrefix"
                                    },
                                    model: {
                                      value: _vm.$v.form.prefixCountry.$model,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.$v.form.prefixCountry,
                                          "$model",
                                          $$v
                                        )
                                      },
                                      expression: "$v.form.prefixCountry.$model"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { sm: "12", xl: "7" } },
                            [
                              _c(
                                "b-form-group",
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      type: "number",
                                      placeholder: _vm.$t(
                                        "signupOH.registerPhoneNumber"
                                      ),
                                      state: _vm.validateState("phoneNumber")
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.resetForm()
                                      }
                                    },
                                    model: {
                                      value: _vm.$v.form.phoneNumber.$model,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.$v.form.phoneNumber,
                                          "$model",
                                          $$v
                                        )
                                      },
                                      expression: "$v.form.phoneNumber.$model"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _vm.form.trySubmit
                                    ? _c(
                                        "b-form-invalid-feedback",
                                        {
                                          attrs: {
                                            state: _vm.form.phoneNumber != null
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.$t(
                                                  "signupOH.errors.enterPhoneNumber"
                                                )
                                              )
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        [
                          _c("v-select", {
                            attrs: {
                              id: "lang",
                              multiple: "",
                              getOptionLabel: function(option) {
                                return _vm.$i18nHelpers.normalizeProp(
                                  "name"
                                ) === "name.es"
                                  ? option.name.es
                                  : option.name.en
                              },
                              placeholder: _vm.$t("signupOH.selectLanguageTxt"),
                              options: this.form.formSelectLang.options
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "option",
                                  fn: function(option) {
                                    return [
                                      _vm._t("option", null, { option: option })
                                    ]
                                  }
                                },
                                {
                                  key: "no-options",
                                  fn: function() {
                                    return [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.$t("signupOH.no-options")
                                          ) +
                                          "\n            "
                                      )
                                    ]
                                  },
                                  proxy: true
                                },
                                {
                                  key: "open-indicator",
                                  fn: function(ref) {
                                    var attributes = ref.attributes
                                    return [
                                      _c(
                                        "span",
                                        _vm._b({}, "span", attributes, false),
                                        [
                                          _c(
                                            "svg",
                                            {
                                              attrs: {
                                                xmlns:
                                                  "http://www.w3.org/2000/svg",
                                                width: "12",
                                                height: "6",
                                                viewBox: "0 0 12 6"
                                              }
                                            },
                                            [
                                              _c("path", {
                                                attrs: {
                                                  id: "Path_4_Copy",
                                                  "data-name": "Path 4 Copy",
                                                  d: "M0,0,6,6,0,12Z",
                                                  transform:
                                                    "translate(12) rotate(90)",
                                                  fill: "#8a8a8a"
                                                }
                                              })
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            ),
                            model: {
                              value: _vm.$v.form.selectedLangs.$model,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.$v.form.selectedLangs,
                                  "$model",
                                  $$v
                                )
                              },
                              expression: "$v.form.selectedLangs.$model"
                            }
                          }),
                          _vm._v(" "),
                          _vm.form.trySubmit
                            ? _c(
                                "b-form-invalid-feedback",
                                {
                                  attrs: {
                                    state: _vm.validateState("selectedLangs")
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm.$t("signupOH.errors.enterLang")
                                      )
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      !_vm.inOpensalud360()
                        ? _c(
                            "b-form-group",
                            [
                              _c("base-select", {
                                attrs: {
                                  id: "discovery",
                                  state: _vm.validateState("discoveryCheck"),
                                  searchable: true,
                                  label: "text",
                                  placeholder: _vm.$t(
                                    "signupOH.selectDiscovery"
                                  ),
                                  options: this.form.selectDiscovery.options
                                },
                                model: {
                                  value: _vm.form.discoveryCheck,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "discoveryCheck", $$v)
                                  },
                                  expression: "form.discoveryCheck"
                                }
                              }),
                              _vm._v(" "),
                              _vm.form.trySubmit
                                ? _c(
                                    "b-form-invalid-feedback",
                                    {
                                      attrs: {
                                        state: _vm.form.discoveryCheck != null
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "signupOH.errors.enterDiscoveryType"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "base-checkbox",
                        {
                          model: {
                            value: _vm.form.termsAccepted,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "termsAccepted", $$v)
                            },
                            expression: "form.termsAccepted"
                          }
                        },
                        [
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t("signupOH.accept-terms-patient")
                              )
                            }
                          }),
                          _vm._v(" "),
                          _vm.form.trySubmit
                            ? _c(
                                "b-form-invalid-feedback",
                                {
                                  attrs: {
                                    state: _vm.validateState("termsAccepted")
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("signupOH.errors.termsAccepted")
                                    )
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "base-checkbox",
                        {
                          model: {
                            value: _vm.form.privacyAccepted,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "privacyAccepted", $$v)
                            },
                            expression: "form.privacyAccepted"
                          }
                        },
                        [
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t("signupOH.accept-privacy-patient")
                              )
                            }
                          }),
                          _vm._v(" "),
                          _vm.form.trySubmit
                            ? _c(
                                "b-form-invalid-feedback",
                                {
                                  attrs: {
                                    state: _vm.validateState("privacyAccepted")
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("signupOH.errors.privacyAccepted")
                                    )
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        {
                          staticStyle: {
                            "align-items": "center",
                            "justify-content": "center",
                            "padding-bottom": "1rem",
                            "text-align": "center"
                          }
                        },
                        [
                          _c("VueRecaptcha", {
                            attrs: {
                              sitekey: _vm.siteKey,
                              "load-recaptcha-script": true
                            },
                            on: {
                              verify: _vm.handleSuccess,
                              error: _vm.handleError,
                              expired: _vm.handleError
                            }
                          }),
                          _vm._v(" "),
                          _vm.form.trySubmit
                            ? _c(
                                "b-form-invalid-feedback",
                                {
                                  attrs: { state: _vm.validateState("captcha") }
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_vm.$t("signupOH.errors.captcha"))
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-button",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { type: "button", variant: "primary" },
                      on: { click: _vm.signUpCheck }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("signupOH.signup-submit")) +
                          "\n      "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("hr"),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("signUp.already-registered")) + ", "),
                    _c("a", { attrs: { href: "/sign-in" } }, [
                      _vm._v(_vm._s(_vm.$t("sign-up-href")))
                    ]),
                    _vm._v(".")
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-modal",
                {
                  attrs: {
                    "title-class": "title-modal",
                    centered: "",
                    "no-close-on-esc": "",
                    "no-close-on-backdrop": "",
                    "hide-header-close": ""
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "modal-footer",
                        fn: function() {
                          return [
                            _c(
                              "b-button",
                              {
                                attrs: { variant: _vm.okBtnVariant },
                                on: {
                                  click: function($event) {
                                    return _vm.signUp()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n    " +
                                    _vm._s(_vm.$t("signupOH.continue")) +
                                    "\n    "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-button",
                              {
                                attrs: { variant: _vm.cancelBtnVariant },
                                on: {
                                  click: function($event) {
                                    return _vm.builtInCancelBNP()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n     " +
                                    _vm._s(_vm.$t("signupOH.cancel")) +
                                    "\n    "
                                )
                              ]
                            )
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    false,
                    535626102
                  ),
                  model: {
                    value: _vm.visibleModalMessageInfo,
                    callback: function($$v) {
                      _vm.visibleModalMessageInfo = $$v
                    },
                    expression: "visibleModalMessageInfo"
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "text-center" },
                    [
                      _vm._l(_vm.codeInfo.infoMessages, function(
                        translation,
                        index
                      ) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticStyle: { "margin-bottom": "1rem" }
                          },
                          [
                            _c(
                              "h6",
                              {
                                staticStyle: {
                                  "margin-bottom": "0rem !important"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$i18nHelpers.normalize(translation)
                                  )
                                )
                              ]
                            )
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _c("div", { staticStyle: { "margin-bottom": "1rem" } }, [
                        _c("h6", [_vm._v(_vm._s(_vm.$t("bnpMSG2")))])
                      ])
                    ],
                    2
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "b-modal",
                {
                  attrs: {
                    "title-class": "title-modal",
                    centered: "",
                    "no-close-on-esc": "",
                    "no-close-on-backdrop": "",
                    "hide-header-close": ""
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "modal-footer",
                        fn: function() {
                          return [
                            _c(
                              "b-button",
                              {
                                attrs: { variant: _vm.okBtnVariant },
                                on: {
                                  click: function($event) {
                                    return _vm.builtInOkFnBusiness()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n    " +
                                    _vm._s(_vm.$t("signupOH.continue")) +
                                    "      \n    "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-button",
                              {
                                attrs: { variant: _vm.cancelBtnVariant },
                                on: {
                                  click: function($event) {
                                    return _vm.builtInCancelFnBusiness()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n     " +
                                    _vm._s(_vm.$t("signupOH.cancel")) +
                                    "      \n    "
                                )
                              ]
                            )
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    false,
                    31656633
                  ),
                  model: {
                    value: _vm.visibleModalBusiness,
                    callback: function($$v) {
                      _vm.visibleModalBusiness = $$v
                    },
                    expression: "visibleModalBusiness"
                  }
                },
                [
                  _c("div", { staticClass: "text-center" }, [
                    _c("div", { staticStyle: { "margin-bottom": "1rem" } }, [
                      _c(
                        "h6",
                        { staticStyle: { "margin-bottom": "0rem !important" } },
                        [_vm._v(_vm._s(_vm.$t("signupOH.modalBusiness")) + " ")]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticStyle: { "margin-bottom": "1rem" } }, [
                      _c("h6", [
                        _vm._v(_vm._s(_vm.$t("signupOH.modalBusiness2")))
                      ])
                    ])
                  ])
                ]
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.userRegistered
        ? _c("div", { attrs: { id: "account-confirmation" } }, [
            _c("p", {
              staticClass: "text-left",
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t("signupOH.account-confirmation", {
                    email: _vm.$v.form.email.$model
                  })
                )
              }
            })
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7820e2fe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7820e2fe","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/PatientSignupForm.vue
// module id = 2963
// module chunks = 1 142